module.exports = new __parcel__URL__("logo_ecn.bd8d5aca.svg").toString();